"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberBubble = exports.NumberBubbleDefaultProps = exports.NumberBubbleFontSizes = exports.NumberBubbleNumericSizes = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
exports.NumberBubbleNumericSizes = {
  tiny: 24,
  small: 36,
  medium: 48,
  large: 56,
  veryLarge: 80,
  huge: 144
};
exports.NumberBubbleFontSizes = {
  tiny: 11,
  small: 15,
  medium: 20,
  large: 24,
  veryLarge: 32,
  huge: 56
};
exports.NumberBubbleDefaultProps = {
  size: 80
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 500;\n    background: ", ";\n    color: ", ";\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    border: 2px solid ", ";\n    transition: border-color 0.3s;\n    text-decoration: none;\n\n    ", "\n  "], ["\n    font-weight: 500;\n    background: ", ";\n    color: ", ";\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    border: 2px solid ", ";\n    transition: border-color 0.3s;\n    text-decoration: none;\n\n    ", "\n  "])), theme_1.theme.COLOR('light'), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('dark'), function (_a) {
    var size = _a.size,
      fontSize = _a.fontSize;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n       width: ", "px;\n       height: ", "px;\n       font-size: ", ";\n    "], ["\n       width: ", "px;\n       height: ", "px;\n       font-size: ", ";\n    "])), size, size, theme_1.theme.FONT_SIZE(fontSize));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var NumberBubble = function (props) {
  var className = props.className,
    children = props.children,
    text = props.text;
  var size = (0, lodash_1.isNumber)(props.size) ? props.size : exports.NumberBubbleNumericSizes[props.size];
  var multiplier = text && text.length ? text.length === 1 ? 0.45 : 0.5 - 0.05 * text.length : 0.45;
  var fontSize = (0, lodash_1.isNumber)(props.fontSize) ? props.fontSize : (0, lodash_1.isNumber)(props.size) ? multiplier * size : exports.NumberBubbleFontSizes[props.size];
  return react_1.default.createElement(My.Container, {
    size: size,
    fontSize: fontSize,
    className: className
  }, text || children);
};
exports.NumberBubble = NumberBubble;
exports.NumberBubble.defaultProps = exports.NumberBubbleDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;